import React, { useEffect, useState } from "react";
import { BrowserInfoDT } from "services/apis/sys/user-api";
import { getBrowserFinger } from "utils/browserFingerUtil";

const FingerprintComponent: React.FC = () => {
  const [fingerprintData, setFingerprintData] = useState<BrowserInfoDT | null>(null);

  useEffect(() => {
    getBrowserFinger().then((data) => {
      setFingerprintData(data);
    });
  }, []);

  return (
    <>
      {fingerprintData ? (
        <pre className=" text-wrap">{JSON.stringify(fingerprintData, null, 2)}</pre>
      ) : (
        <p>获取指纹中...</p>
      )}
    </>
  );
};

export default FingerprintComponent;
